import Snap from "snapsvg";
import {DoorShape} from "./door-shape";

export class DesignPreviewController {

    constructor($log, $timeout, $window, $rootScope, UserSessionService) {
        'ngInject';

        this.$log = $log;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.userSessionService = UserSessionService;

    }

    $onInit() {

        this.$log.debug('DesignPreviewController::$onInit');

        //this.image = this.userSessionService.getBaseImage();
        if (this.base) {
            this.image = this.userSessionService.getBaseImage();
        } else {
            this.image = this.userSessionService.getImage();
        }
        this.doors = this.userSessionService.getDoors();
        this.selectedDoor = this.userSessionService.getSelectedDoor();

        this.canvasElement = this.$window.document.querySelector('.design-preview__canvas');
        this.imageElement = this.$window.document.querySelector('.design-preview__image');

        this.canvasElement.addEventListener('mousedown', this.deselectAll.bind(this));

        this.imageElement.addEventListener('load', this.onImageLoaded.bind(this));
        this.$window.addEventListener('resize', this.draw.bind(this));

        this.initCanvas();
        this.initListeners();

    }

    $onDestroy() {
        this.$log.debug('DesignPreviewController::$onDestroy');

        this.canvasElement.addEventListener('mousedown', this.deselectAll);

        this.imageElement.removeEventListener('load', this.onImageLoaded);
        this.$window.removeEventListener('resize', this.draw);

        this.doorsUpdatedDereg();
        this.selectedDoorDereg();
        this.imageRenderedDereg();
    }

    onImageLoaded() {
        this.$log.debug('image loaded');
        this.$timeout(() => {
            this.loading = false;
        });
        this.draw();
    }

    initCanvas() {

        this.canvas = new Snap(this.canvasElement);

    }

    initListeners() {

        this.doorsUpdatedDereg = this.$rootScope.$on('UserSessionService::doorsUpdated', () => {
            this.doors = this.userSessionService.getDoors();
            this.selectedDoor = this.userSessionService.getSelectedDoor();
            this.redraw();
        });

        this.selectedDoorDereg = this.$rootScope.$on('UserSessionService::selectedDoorUpdated', () => {
            this.selectedDoor = this.userSessionService.getSelectedDoor();

            let index = this.doors.indexOf(this.selectedDoor);

            this.doorShapes.forEach((doorShape, i) => {
                doorShape.toggleSelect(i === index);
            });

        });

        this.imageRenderedDereg = this.$rootScope.$on('UserSessionService::imageRendered', () => {
            this.$timeout(() => {
                this.loading = true;
            });
            this.image = this.userSessionService.getImage();
        });

    }

    deselectAll() {

        this.doorShapes.forEach((doorShape, i) => {
            doorShape.toggleSelect(false);
        });
        //this.userSessionService.setSelectedDoor(null);
    }

    getImageWidth() {
        return this.imageElement.clientWidth;
    }

    getImageHeight() {
        return this.imageElement.clientHeight;
    }

    getCanvasWidth() {
        return this.canvasElement.clientWidth;
    }

    getCanvasHeight() {
        return this.canvasElement.clientHeight;
    }

    resetCanvasSize() {
        this.canvasElement.style.width = this.getImageWidth() + 'px';
        this.canvasElement.style.height = this.getImageHeight() + 'px'
    }

    redraw() {
        this.clear();
        this.draw();
    }

    clear() {

        if (!this.canvas) return;

        this.canvas.clear();
        this.doorShapes = [];
    }

    draw() {

        this.$log.debug('drawing', this.doors);

        if (!this.canvas) return;

        this.clear();

        this.resetCanvasSize();

        this.doors.map((door) => {

            let points = this.convertPointsToCanvas(door.getPoints());

            let doorShape = new DoorShape(this.canvas, {
                door: door,
                points: points,
                selected: this.selectedDoor === door,
                editable: this.editable,
                onClick: this.onDoorShapeClick.bind(this),
                onDrag: this.onDoorShapeDrag.bind(this),
                onDragStart: this.onDoorShapeDragStart.bind(this),
                onDragEnd: this.onDoorShapeDragEnd.bind(this)
            });

            this.doorShapes.push(doorShape);

        });

    }

    onDoorShapeClick(doorShape) {
        this.$log.debug('DesignPreviewController::onDoorShapeClick');

        let index = this.doorShapes.indexOf(doorShape);
        let door = this.doors[index];
        this.$timeout(() => {
            this.userSessionService.setSelectedDoor(door);
        });
    }

    onDoorShapeDrag(doorShape) {
        this.$log.debug('DesignPreviewController::onDoorShapeDrag');

        let index = this.doorShapes.indexOf(doorShape);
        let door = this.doors[index];
        this.$timeout(() => {
            door.setPoints(this.convertPointsFromCanvas(doorShape.getPoints()));
        });
    }

    onDoorShapeDragStart(doorShape) {
        this.$log.debug('DesignPreviewController::onDoorShapeDragStart');

    }

    onDoorShapeDragEnd(doorShape) {
        this.$log.debug('DesignPreviewController::onDoorShapeDragEnd');

        let index = this.doorShapes.indexOf(doorShape);
        let door = this.doors[index];
        this.$timeout(() => {
            door.setPoints(this.convertPointsFromCanvas(doorShape.getPoints()));
        });
    }

    convertPointsToCanvas(points) {

        return points.map((num, index) => {

            let val;

            if (index % 2 === 0) {
                val = Math.max((num * this.getCanvasWidth() / this.image.width), 1); // min value of 1 to stop Infinity
            } else {
                val = Math.max((num * this.getCanvasHeight() / this.image.height), 1); // min value of 1 to stop Infinity
            }

            return Math.round(val * 10) / 10;

        });

    }

    convertPointsFromCanvas(points) {

        return points.map((num, index) => {

            let val;

            if (index % 2 === 0) {
                val = (num / this.getCanvasWidth() * this.image.width);
            } else {
                val = (num / this.getCanvasHeight() * this.image.height);
            }

            return Math.round(val * 10) / 10;

        });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/design-preview/design-preview.controller.js